import script from "./QuizAnswer.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizAnswer.vue?vue&type=script&setup=true&lang=js"

import "./QuizAnswer.vue?vue&type=style&index=0&id=42683b52&scoped=true&lang=css"

import exportComponent from "/builds/kmkn5581/messequiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42683b52"]])

export default __exports__